export default __webpack_public_path__ + "static/media/0.cdf743c8.png";